<template>
<div class="form">
  <a-card size="small" title="环境主备切换">
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">

             <a-form-model-item ref="shortdomain" label="操作域名" prop="shortdomain">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.shortdomain"
                     @blur="
                        () => {
                            $refs.shortdomain.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>

            <a-form-model-item ref="enable" label="切换开关" prop="enable">
                <a-radio-group v-if="is_vue_task" v-model="record.enable">
                    <a-radio value="true">
                    开启
                    </a-radio>
                    <a-radio value="false">
                    关闭
                    </a-radio>
                </a-radio-group>
            </a-form-model-item>

            <a-form-model-item ref="apiaddress" label="接口地址" prop="apiaddress">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.apiaddress"
                     @blur="
                        () => {
                            $refs.apiaddress.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>

            <a-form-model-item v-show="is_vue_task"  :wrapper-col="{ span: 14, offset: 8 }" >
                <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                    切换
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>



     </a-form-model>

 </a-card>
</div>

</template>
<script>
export default {
    data() {
        return {
            is_vue_task : true,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                shortdomain:[
                    { required: true, message: ' 请输操作域名 ', trigger: 'blur' },

                ],
                enable:[
                    { required: true, message: ' 请选择开关 ', trigger: 'blur' },

                ],
                apiaddress:[
                    { required: true, message: ' 请填写接口地址 ', trigger: 'blur' },

                ]

            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                shortdomain:'yxlpos',
                enable:'false',
                apiaddress:'http://192.168.3.81:10000/switch'
            }
        };
    },
    methods: {
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    that.$store
                        .dispatch({
                            type: "redis/routesend",
                            params: {
                                ...that.record
                            }
                        })
                        .then((response) => {
                         if(response.data.success == '1'){
                                //that.handleCancel();
								this.confirmLoading = false;
                                that.message.success('调用成功');
                            }else{
								//that.handleCancel();
								this.confirmLoading = false;
								that.message.success('调用失败');
                            }
                        });
                } else {
                    console.log('error submit!!');
                    this.confirmLoading = false;
                    return false;
                }
            });

        },
        triggerValidate(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(valid)
                }
            })
            this.confirmLoading = false;

        },

        handleCancel() {
            this.resetForm();
            this.confirmLoading = false;
            // this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.shortdomain = '';
            this.record.enable = '';
            this.record.apiaddress = '';
        }
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
